import React, {Component} from 'react';
import Menu from "../components/Menu";
import Axios from "axios";
import ApiUrl from "../AppUrl/ApiUrl";
import {toast} from "react-toastify";
import Loading from "../components/Loading";

class EditPackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: "",
            id: props.match.params.id,
            name: "",
            spin: "",
            ads: "",
            amount: "",
            loading: true,
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem("admintoken");
        this.setState({ token: token });

        try {
            const res = await Axios.get(ApiUrl.baseurl + "plan/" + this.state.id);
            if (res.data) {
                const plan = res.data.data || res.data; // ডাটা স্ট্রাকচার অনুযায়ী
                this.setState({
                    name: plan.name || "",
                    spin: plan.spin || "",
                    ads: plan.ads || "",
                    amount: plan.amount || "",
                    loading: false
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
            toast.error("Failed to load plan data");
        }
    }

    onChangeInput = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmitForm = (event) => {
        event.preventDefault();
        var val = this.state;

        var formData = new FormData();
        formData.append("token", val.token);
        formData.append("name", val.name);
        formData.append("spin", val.spin);
        formData.append("ads", val.ads);
        formData.append("amount", val.amount);

        Axios.post(ApiUrl.baseurl + "plan/update/" + val.id, formData)
            .then(res => {
                if(res.data.success){
                    toast.success(res.data.success, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTimeout(
                        () => this.props.history.push(`/package`), // আপনার রুট রাউট অনুযায়ী পরিবর্তন করতে পারেন
                        1000
                    );
                } else {
                    toast.error(res.data.error || "Something went wrong", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(error => {
                console.log(error);
                toast.error(error.response?.data?.error || "Server error occurred");
            });
    }

    render() {
        return (
            <Menu title="Edit Package">
                <h3 className="bg-white title-head"> Edit Package </h3>
                <div className="container-fluid currency-add">
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.loading === true ?
                                <Loading /> :
                                <form onSubmit={this.onSubmitForm}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label>Plan Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                required
                                                value={this.state.name}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter plan name"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Spin Count</label>
                                            <input
                                                type="text"
                                                name="spin"
                                                required
                                                value={this.state.spin}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter spin limit"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Ads Count</label>
                                            <input
                                                type="text"
                                                name="ads"
                                                required
                                                value={this.state.ads}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter ads limit"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Amount</label>
                                            <input
                                                type="text"
                                                name="amount"
                                                required
                                                value={this.state.amount}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter package amount"
                                            />
                                        </div>
                                        <div className="col-md-12 mt-4 mb-5">
                                            <button type="submit" className="btn btn-primary shadow-none">Update</button>
                                        </div>
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default EditPackage;